import { Component, OnInit } from '@angular/core';
import { BibliographyService } from '../../../services/bibliography.service';
import { BibListFilters } from '../../../models/bib-list-filters';

@Component({
  selector: 'app-biblio-search-form',
  templateUrl: './biblio-search-form.component.html',
  styleUrls: ['./biblio-search-form.component.css']
})
export class BiblioSearchFormComponent implements OnInit {
    bibListFilters: BibListFilters;

    constructor(
        private bibliographyService: BibliographyService) {
    }

    ngOnInit(): void {
        /* Init filtering values */
        this.bibliographyService.getBibListFilters()
            .subscribe(response => {
                this.bibListFilters = response;
            },
                err => console.error(err));
    }

    search(): void {
        // this.bibListFilters.date = this.bibListFilters.date; // force date object update
        this.bibliographyService.updateFilters(this.bibListFilters);
    }

}



// WEBPACK FOOTER //
// ./src/app/components/ui/biblio-search-form/biblio-search-form.component.ts